import script from "./customIptvDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./customIptvDetail.vue?vue&type=script&lang=ts&setup=true"

import "./customIptvDetail.vue?vue&type=style&index=0&id=163a74f3&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-163a74f3"]])

export default __exports__